<template>
  <div v-if="columnConfig.column_display">
    <vue-good-table
      ref="table"
      mode="remote"
      :rows="list"
      :columns="columns"
      :totalRows="totalRecords"
      :sort-options="sortOption"
      :search-options="searchOption"
      :pagination-options="pagination"
      @on-search="onSearch"
      @on-sort-change="onSortChange"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'status'">
          <span>
            {{ props.row.status | toUpperCase }}
          </span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <div slot="table-actions" class="table-actions">

        <p
          v-if="+campaign.monthlyshort.progress_upload_manual === 0"
          class="text-primary"
        >
          Auto Update
        </p>
        <ImportProgress
          v-else
          @updated="fetch"
          :campaign="campaign"
          :columnConfig="columnConfig"
        />
        <div class="Excel">
          <button @click="exportToExcel" class="btn btn-default">
            <i class="fa fa-file-excel-o"></i>
            Export to Excel
          </button>
        </div>
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import { progressBarService } from "@/api/client";
import vueGoodTableMixins from "@/mixins/vue-good-table";

import { monthlyTableColumns } from "@/views/progressbar/model";
import ImportProgress from "@/views/progressbar/ProgressUpdate/MonthlyShort/ImportProgress.vue";

export default {
  name: "MonthlyShortTable",

  props: ["campaign", "columnConfig"],

  components: { ImportProgress },

  mixins: [vueGoodTableMixins],

  data() {
    return {
      list: [],
      transactions: [],
    };
  },

  watch: {
    transactions(v) {
      this.list = v;
    },

    async "$route.query"() {
      await this.fetch();
      this.initialTableState();
    },
  },

  beforeMount() {
    this.initialTableState();
  },

  mounted() {
    this.initialTableSearchState();
  },

  computed: {
    columns() {
      if (!this.columnConfig.column_display) {
        return monthlyTableColumns;
      }

      return this.columnConfig.column_display.map((o, i) => {
        return {
          label: o,
          field: this.columnConfig.column_key[i],
          sortable: this.columnConfig.column_sortable[i] === 1,
        };
      });
    },
  },

  methods: {
    getParams() {
      let params = {};

      const { sortBy, sortDir, perPage, page, searchTerm } = this.$route.query;

      const pageSize = perPage || this.pagination.perPage;

      if (sortBy) {
        params.order_by = sortBy;
      }

      if (sortDir) {
        params.desc = sortDir == "desc" ? 1 : 0;
      }

      if (searchTerm) {
        params.search = searchTerm;
      }

      if (page) {
        params.start = page ? (page - 1) * pageSize : 0;
      }

      params.count = pageSize || 10;

      return params;
    },

    async fetch() {
      const id = this.$route.params.id;
      const params = this.getParams();

      const {
        data,
        total_records,
      } = await progressBarService.getProgressUpdateDetail(id, params);

      this.transactions = data;
      this.totalRecords = total_records;
    },

    async exportToExcel() {
      try {
        const id = this.$route.params.id;
        const response = await progressBarService.downloadProgressUpdate(id);

        const blob = new Blob([response.data], {
          type: "application/vnd.ms-excel",
        });

        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = `Progress_Update_Monthlyshort_${id}_${new Date().getTime()}.xlsx`;
        a.click();
      } catch (error) {
        console.log(error);
      }
    },
  },

  async created() {
    await this.fetch();
  },
};
</script>

<style scoped>
.page-header-right {
  position: absolute;
  top: 40px;
  bottom: 0;
  right: 30px;
}
.page-header-actions {
  margin-top: 40px;
  position: absolute;
  bottom: 20px;
}
.panel {
  margin-top: 3px;
}
.show_entries {
  margin-top: 20px;
}
.Excel {
  margin: auto 1rem;
  display: inline-block;
}
.table-actions {
  display: flex;
}
</style>

<style lang="scss">
.vgt-global-search {
  padding: 1em 0px;
  display: flex;
  align-items: center;
}
</style>
